import { Loader2 } from 'lucide-react';

interface OnboardingProgressItem {
  key: string;
  label: string;
  pct: number;
  onView: () => void;
  viewLabel: string;
}

const OnboardingProgressBar = ({ items }: { items: OnboardingProgressItem[] }) => {
  if (!items.length) return null;

  return (
    <div className="shrink-0 flex flex-col border-b border-primary/20 bg-primary/5">
      {items.map(item => (
        <div key={item.key} className="flex items-center gap-3 px-6 py-2.5">
          <Loader2 className="w-3.5 h-3.5 animate-spin text-primary shrink-0" />
          <span className="text-[13px] font-medium text-foreground truncate">{item.label}</span>
          <div className="w-32 h-1.5 rounded-full bg-primary/10 overflow-hidden shrink-0">
            <div
              className="h-full rounded-full bg-primary transition-[width]"
              role="progressbar"
              aria-label={item.label}
              aria-valuenow={Math.round(item.pct)}
              aria-valuemin={0}
              aria-valuemax={100}
              style={{ width: `${Math.round(item.pct)}%` }}
            />
          </div>
          <span className="text-[13px] text-muted-foreground tabular-nums shrink-0">{Math.round(item.pct)}%</span>
          <button
            type="button"
            className="ml-auto text-[13px] text-primary font-medium hover:underline shrink-0"
            onClick={item.onView}
          >
            {item.viewLabel}
          </button>
        </div>
      ))}
    </div>
  );
};

export default OnboardingProgressBar;
